module.exports = __webpack_public_path__ + "6007ab7c7f0919ba9dee20992152254f.MP3";